import React from "react";

function DriverConditionSelector({ conditions, selectedCondition, onConditionChange, t }) {
  const translatedConditions = conditions?.map((v) => ({
    ...v,
    title: v.value === "with_driver" ? t("with_driver") : t("without_driver"),
  }));

  return (
    <div className="flex gap-6 mb-3">
      {translatedConditions.map((item, idx) => (
        <label key={idx} className="flex items-center gap-3 text-white cursor-pointer">
          <input
            type="checkbox"
            checked={item.value === selectedCondition}
            onChange={(e) => onConditionChange(e.target.value)}
            value={item.value}
            className="w-6 h-6 text-red-500 rounded border-slate-600 focus:ring-red-500 focus:ring-offset-slate-800"
          />
          <span className="text-base font-medium md:text-lg">{item.title}</span>
        </label>
      ))}
    </div>
  );
}

export default DriverConditionSelector;
